export default "__VITE_ASSET__7DtiLeXz__"